module.exports = __webpack_public_path__ + "img/three2Green.8817c963.png";